/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEditClearAll = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M22 22H2v-2h20zM19 6.5l-12.001 12L2.5 14l3.793-3.788.004-.003L14.589 2H19zM5.33 14.002l1.671 1.67 1.67-1.667L7 12.334zm3.088-3.08 1.668 1.669L17 5.673V4h-1.589zM22 18H12v-2h10z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgEditClearAll as EditClearAll };
